import React from "react";
import { GlsSection } from "../../../gls";
import {
  getBackendName,
  getStoredAccountingBackend,
} from "../../../../config/accounting";
import { SettingsManagedPanel } from "../components/SettingsManagedPanel";
import { SettingsLayout } from "../layout/SettingsLayout";

/**
 * ChartOfAccountsPage — `/settings/chart-of-accounts`.
 *
 * The ledgers every bill, invoice, tax rate and bank posts to. Master-admin
 * reads this chart during onboarding and never writes it into the tenant: the
 * tenant syncs its own `gl_maps` from the books system, so after go-live this
 * is the only place it is managed.
 *
 * DELIBERATELY NOT A SECOND IMPLEMENTATION. `GlsSection` already carries the
 * paginated tree, search, the create/edit dialog, the can-delete pre-check and
 * the review-request flow for firms where deletion needs approval, and it is in
 * production at `/dashboard/masters`. Building a settings-flavoured copy would
 * mean two places to fix every bug in all of that. This mounts the real one and
 * supplies the heading, so both doors open on the same room.
 *
 * A consequence worth knowing: `GlsSection` gates its own actions on the GL
 * module permissions. So unlike Company details — which is open to every signed
 * in user by design — this panel respects whatever create/edit/delete rights
 * the user already has, and shows the table read-only to everyone else.
 */
export const ChartOfAccountsPage: React.FC = () => {
  const backendName = getBackendName(getStoredAccountingBackend());

  return (
    <SettingsLayout wide>
      <SettingsManagedPanel
        title="Chart of Accounts"
        description={`The ledger accounts your books post to, synced from ${backendName}.`}
      >
        <GlsSection showHeader={false} className="flex w-full flex-col items-start gap-6" />
      </SettingsManagedPanel>
    </SettingsLayout>
  );
};
